export default "__VITE_PUBLIC_ASSET__f3718dcb__"